export default {
  "invite": {
    "title": "Paybet-এ স্বাগতম",
    "tab1": "ইমেইল",
    "tab2": "মোবাইল",
    "formPh1": "ইমেইল ঠিকানা লিখুন",
    "formPh5": "মোবাইল নম্বর লিখুন",
    "formPh2": "লগইন পাসওয়ার্ড সেট করুন",
    "formPh3": "লগইন পাসওয়ার্ড পুনরায় লিখুন",
    "formPh4": "যাচাই কোড লিখুন",
    "btnTxt1": "কোড পান",
    "btnTxt2": "নিবন্ধন",
    "successTxt1": "Paybet নিবন্ধন সফল",
    "successTxt2": "ডাউনলোড",
    "errorTxt1": "মোবাইল নম্বর ফরম্যাট ভুল",
    "errorTxt2": "ইমেইল ফরম্যাট ভুল",
    "errorTxt3": "মোবাইল নম্বর ইতিমধ্যে নিবন্ধিত",
    "errorTxt4": "ইমেইল ঠিকানা ইতিমধ্যে নিবন্ধিত",
    "errorTxt5": "যাচাই কোড ভুল বা মেয়াদোত্তীর্ণ",
    "errorTxt6": "পাসওয়ার্ড মেলে না",
    "errorTxt7": "পাসওয়ার্ড ৮ অক্ষরের বেশি হতে হবে",
    "errorTxt8": "পাসওয়ার্ডে অন্তত ১টি সংখ্যা থাকতে হবে",
    "errorTxt9": "পাসওয়ার্ডে অন্তত ১টি বর্ণ থাকতে হবে"
    ,"countryNotAllowed": "বর্তমান দেশটি নিবন্ধন সমর্থন করে না"
  },
  "Sort_Picker_title": "দয়া করে আপনার আন্তর্জাতিক ক্ষেত্র নির্বাচন করুন",
  "ReconfirmModalText1": "নিরাপত্তা যাচাই",
  "verifySuccess": "যাচাই সফল",
  "verifyError": "যাচাই ব্যর্থ, পুনরায় চেষ্টা করুন",
  "sliderText": "ডানদিকে স্লাইড করে যাচাই সম্পন্ন করুন",
  "download": {
    "title": "দ্রুত উপার্জন শুরু করুন!",
    "subtitle": "এখনই PayBet ডাউনলোড করুন!",
    "tagline": "নিরাপদ | সহজ | লাভজনক",
    "downloadBtn": "এখনই PayBet অ্যাপ ডাউনলোড করুন",
    "whyChoose": "কেন PayBet নির্বাচন করবেন?",
    "feature1Title": "দ্রুত লেনদেন",
    "feature1Desc": "তাত্ক্ষণিক জমা ও উত্তোলন",
    "feature2Title": "সহজ আয়",
    "feature2Desc": "প্রতি ক্রয় ও বিক্রয়ে সহজে কমিশন উপার্জন করুন",
    "feature3Title": "নিরাপদ এবং নির্ভরযোগ্য",
    "feature3Desc": "ব্যাংক-স্তরের এনক্রিপশন সহ তৈরি",
    "feature4Title": "ব্যবহার করা সহজ",
    "feature4Desc": "স্বয়ংক্রিয় মোড এবং পেটেন্টপ্রাপ্ত প্রযুক্তি",
    "stepsTitle": "আয় শুরু করার ৩টি ধাপ",
    "step1Title": "PayBet অ্যাপ ডাউনলোড এবং ইনস্টল করুন",
    "step2Title": "রেজিস্টার করুন এবং আপনার UPI / ব্যাংক কার্ড সংযুক্ত করুন",
    "step3Title": "জমা, উত্তোলন ও কমিশন উপার্জন শুরু করুন",
    "bottomText": "PayBet অ্যাপে আরও নগদ পুরস্কার ও বোনাস আবিষ্কার করুন!",
    "copyright": "২০২৫ PayBet। সর্বস্বত্ব সংরক্ষিত।"
  },
   inviteJt: {
    title: 'JTPay-এ স্বাগতম',
    successTxt1: "JTPay নিবন্ধন সফল",
    successTxt2: "JTpay APP",
  },
}
